import { render, staticRenderFns } from "./OrderBoxTime.vue?vue&type=template&id=3bc0a9d6&"
import script from "./OrderBoxTime.vue?vue&type=script&lang=js&"
export * from "./OrderBoxTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bc0a9d6')) {
      api.createRecord('3bc0a9d6', component.options)
    } else {
      api.reload('3bc0a9d6', component.options)
    }
    module.hot.accept("./OrderBoxTime.vue?vue&type=template&id=3bc0a9d6&", function () {
      api.rerender('3bc0a9d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/OrderBoxTime.vue"
export default component.exports